export default "__VITE_ASSET__BY8qFnU8__"